'use strict';

// Provided by the Address Validation & SAP teams
module.exports.ADDRESS_LINE = 36;
module.exports.CITY = 80;
module.exports.STATE = 40;
module.exports.COUNTRY = 40;
module.exports.POSTAL_CODE = 15;
